<lib-info-alert *ngIf="userQuestionnaire.showNotes" [message]="'CHECK.NOTES_MESSAGE_ALERT' | translate"></lib-info-alert>

<div class="notes-section">
    <p class="label">{{ 'CHECK.EDITOR.SHOW_NOTES_REPORT' | translate}}</p>
    <p class="switch-p" [ngClass]="{'disabled': !editable}">
        <mat-slide-toggle [(ngModel)]="userQuestionnaire.showNotes" (click)="onShowNotesClick()">{{ (userQuestionnaire.showNotes ? 'CONFIGURE.ACTIVE' : 'CONFIGURE.INACTIVE') | translate }}</mat-slide-toggle>
    </p>
    <p class="deactivate-label">{{ 'CHECK.DEACTIVATE_NOTES' | translate }}</p>
</div>
        
<label class="input-floating">
    <textarea #notes cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" type="text" class="form-input notesSection" [placeholder]="'CHECK.COMMENT' | translate"
        (focusout)="onFocusOutTextareaEvent($event)" (click)="clickTextarea()">
    </textarea>
    <span>{{ 'CHECK.NOTES_MESSAGE' | translate }}</span>
</label>
